export function getDiscountDiffValue(originalPrice: number | undefined, salePrice: number | undefined): number {
	const discountValue = Math.max((originalPrice ?? 0) - (salePrice ?? 0), 0);
	const fixedValue = parseFloat(discountValue.toFixed(2));
	return fixedValue;
}
